<template>
  <div class="overflow-mobile">
    <d-row v-if="user.connected">
      <!-- Main Sidebar -->
      <main-sidebar
        :items="sidebarItems"
        @mainContentWidth="setMainContentWidth"
      />

      <d-col
        :class="['main-content', offsetCol, 'offset-md-3']"
        tag="main"
        :lg="contentWidth"
        md="9"
        sm="12"
      >
        <!-- Main Navbar -->
        <main-navbar />

        <router-view />
      </d-col>
    </d-row>
    <d-row v-else>
      <div class="loader">
        {{ user.connected }}
        <spinner w="100" />
      </div>
    </d-row>
  </div>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';

// Main layout components
import MainNavbar from '@/components/layout/MainNavbar/MainNavbar.vue';
import MainSidebar from '@/components/layout/MainSidebar/MainSidebar.vue';
import Spinner from '../components/layout/Loading/spinner';

export default {
  name: 'default',
  components: {
    Spinner,
    MainNavbar,
    MainSidebar,
  },

  computed: {
    user() {
      return this.$store.state.user.informations;
    },
  },

  data() {
    return {
      sidebarItems: getSidebarItems(),
      offsetCol: 'offset-lg-2',
      contentWidth: 10,
    };
  },

  methods: {
    setMainContentWidth(obj) {
      this.offsetCol = obj.offsetCol;
      this.contentWidth = obj.contentWidth;
    },
  },
};
</script>

<style scoped>
.loader {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
}
.overflow-mobile {
  overflow: hidden;
}
</style>
